import React from "react";
import { Outlet } from "react-router-dom";
import CssBaseline from "@mui/material/CssBaseline";
import { NavBar } from "@app.automotus.io/components/NavBar";
import Box from "@mui/material/Box";
import { Theme } from "@mui/material/styles";
import { TosGate } from "@curbpass/components/TosGate";
import { useDashboardNavLinks } from "./useDashboardNavLinks";

export const DashboardLayoutRoute: React.FC = () => {
  const mainRef = React.useRef(null);
  const targets = useDashboardNavLinks();

  return (
    <>
      <CssBaseline />
      <NavBar targets={targets} supportLabel="Resources" supportUrl={process.env.REACT_APP_SUPPORT_URL || ""} />
      <Box
        component="main"
        ref={mainRef}
        sx={{ pt: (theme: Theme) => theme.spacing(11), display: "flex", flexDirection: "column", minHeight: "100vh" }}
      >
        <Outlet />
      </Box>
      <TosGate />
    </>
  );
};

export default DashboardLayoutRoute;
